/* eslint-disable @typescript-eslint/no-explicit-any */
import Qs from 'qs'
import service from '@/services/service'
import { APIBillingCode } from '@/models/api/billing-code.model'

const resource = {
    main: 'services',
    module: 'billing-codes'
}

export class BillingCodesServices {
    public static getBillingCodes () {
        return service.get(`${resource.main}/${resource.module}`)
    }

    public static getBillingCodesPaginate (params: object) {
        return service.get(`${resource.main}/${resource.module}/paginate`, {
            params,
            paramsSerializer: (params) => {
                return Qs.stringify(params, { arrayFormat: 'indices' })
            }
        })
    }

    public static getBillingCodesById (id: number) {
        return service.get(`${resource.main}/${resource.module}/${id}`)
    }

    public static createBillingCodes (params: APIBillingCode) {
        return service.post(`${resource.main}/${resource.module}`, params)
    }

    public static editBillingCodes (params: APIBillingCode) {
        return service.put(`${resource.main}/${resource.module}/${params.billingCodeId}`, params)
    }

    public static deleteBillingCodes (id: number) {
        return service.delete(`${resource.main}/${resource.module}/${id}`)
    }

    public static restoreBillingCodes (id: number) {
        return service.put(`${resource.main}/${resource.module}/restore/${id}`)
    }
}
